export enum FullProfileDialogAnimationsEnum {
    slideInOutAnimation = 'slideInOutAnimation',
    overlayAnimation = 'overlayAnimation'
}
